import state from "./moduleLessonState.js";
import mutations from "./moduleLessonMutations.js";
import actions from "./moduleLessonActions.js";
import getters from "./moduleLessonGetters.js";

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
